import { Button } from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import { palette } from "../../theme/palette";

export const ActionButton = withStyles({
  root: {
    background: palette.typography.white.solid,
    padding: "5px 10px",
    borderRadius: 3,
    border: 0,
    color: palette.typography.black.solid,
    height: "30px",
    "&:hover": {
      backgroundColor: palette.whiteDisabled,
    },
  },
  disabled: {
    background: palette.whiteDisabled,
  },
})(Button);
